<template>
	<CreationWizardStepWrapper>
		<template #header>
			<ChooseAppForButtonDropdownHeader v-bind="$props" v-on="$listeners" />
		</template>
		<ChooseApp
			class="height-100"
			:selectedAppId="selectedAppId"
			@selectApp="selectApp"
			itemName="button dropdown"
			availableItems="dropdown placements"
		/>
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';

import props from './ChooseAppForButtonDropdown.props';
import ChooseAppForButtonDropdownHeader from './ChooseAppForButtonDropdownHeader.vue';
import ChooseApp from '../common/ChooseApp.vue';

export default {
	name: 'ChooseAppForButtonDropdown',
	mixins: [WizardStepMixin],
	props,
	components: { ChooseApp, ChooseAppForButtonDropdownHeader },
	methods: {
		selectApp(v) {
			this.updateState({ key: 'selectedAppId', value: v });
			this.nextStep();
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/components/CreationWizard/assets/top-section.scss';
.list-selector {
	max-height: 300px;
	overflow-y: auto;
}
.bottom-section {
	align-items: flex-end;
	h3 {
		color: #303133;
		a {
			color: #303133;
			font-weight: 400;
		}
	}
}
.reload-button {
	color: var(--bg-color);
	height: 45px !important;
	border-radius: 8px !important;
	font-weight: normal !important;
	background-color: #6762f0 !important;
}
</style>
